import React from 'react'

const TextWidget = ({ container: Container, html, pageType }) => {
  return (
    <Container {...(pageType !== 'article' && { mt: 35 })}>
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </Container>
  )
}

export default TextWidget
